import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ILocation } from '../../interfaces/location'
import { PROD_API_URL } from '../../const/constants'
import { Observable } from 'rxjs'
import { UntypedFormGroup } from '@angular/forms'

@Injectable({
    providedIn: 'root',
})
export class LocationsService {
    constructor(private httpService: HttpClient) {}

    get(): Observable<ILocation[]> {
        return this.httpService.get<ILocation[]>(`${PROD_API_URL}api/locations`)
    }
    getById(locationId: number): Observable<ILocation> {
        return this.httpService.get<ILocation>(
            `${PROD_API_URL}api/locations/${locationId}`
        )
    }
    post(body: UntypedFormGroup): Observable<any> {
        return this.httpService.post<any>(PROD_API_URL + 'api/locations', body)
    }
    put(id: number, body: UntypedFormGroup): Observable<any> {
        return this.httpService.put<any>(
            `${PROD_API_URL}api/locations/${id}`,
            body
        )
    }

    delete(id: number): Observable<any> {
        return this.httpService.delete<any>(
            `${PROD_API_URL}api/locations/${id}`
        )
    }
}
